import { Category } from '../types/category'

/**
 * 지도 마커 필터 타입 enum
 */
export enum MapFilterType {
  ALL = 'all',
  POPULAR = 'popular',
  FOLLOWING = 'following',
  EXPERIENCED = 'experienced',
  PLAYLIST = 'playlist',
  /** 앱 안에서 기록이 있는 장소 전부 (남의 나만 보기·차단 관계 기록은 서버가 뺀다) */
  RECORDED = 'recorded',
}

/**
 * 필터 옵션 목록
 */
export const MAP_FILTERS: Category[] = [
  { id: MapFilterType.POPULAR, label: '추천' },
  { id: MapFilterType.RECORDED, label: '기록된 장소' },
  { id: MapFilterType.FOLLOWING, label: '저장한 장소' },
  { id: MapFilterType.EXPERIENCED, label: '경험한 장소' },
  { id: MapFilterType.PLAYLIST, label: '플레이트리스트' },
]
